import { publishEvent, TelemetryEventData } from "VSS/Telemetry/Services";

export namespace HtmlFieldsMentionsTelemetryConstants {
    export const Area = "HtmlFieldsMentions";

    // Usage scenarios
    export const MentionRenderFail = "MentionRenderFail";
}

/**
 * Helper for comments UI usage telemetry
 */
export namespace HtmlFieldsMentionsUsageTelemetryHelper {
    /**
     * Publish telemetry for when mention decorating fails
     * @param commentLength Total length of new comment
     */
    export function publishMentionRenderFail(errorMessage: string): void {
        _publish(HtmlFieldsMentionsTelemetryConstants.MentionRenderFail, { errorMessage });
    }


    function _publish(featureName: string, properties: { [key: string]: string | number | boolean } = {}): void {
        publishEvent(new TelemetryEventData(HtmlFieldsMentionsTelemetryConstants.Area, featureName, properties));
    }
}